import { BaseType } from 'models/Ressource';

export const rowSpan = (arrayIn, name) => {
  let indexOfName = 0;
  const arrayOut = [];
  for (let index = 0; index < arrayIn.length; index += 1) {
    if (index > 0 && arrayIn[index][name] === arrayOut[indexOfName][name]) {
      arrayOut[index] = {
        ...arrayIn[index],
        [name]: undefined,
      };
      arrayOut[indexOfName].spanCount += 1;
    } else {
      indexOfName = index;
      arrayOut[index] = {
        ...arrayIn[index],
        spanCount: 1,
      };
    }
  }
  return arrayOut;
};

export const sortByCreatedDateDesc = (a: BaseType, b: BaseType) => {
  if (a.created_at > b.created_at) return 1;
  if (a.created_at < b.created_at) return -1;
  return 0;
};
